import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
} from "constants/FormatDataContanst";

export const getReportStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: t("auth_status_report.m"),
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      text: t("auth_status_report.p"),
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_APPROVE]: {
      text: t("auth_status_report.a"),
      badgeColor: "badge-soft-success",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
  };
};

export const TYPE_REPORT = {
  ERROR: "ERROR", // type 10,
  DATA: 1, // Bảng kê dữ liệu hóa đơn,
  USE: 2, // Bảng kê tình hình sử dụng
  TRANSFER: 50, // Báo cáo đối soát truyền nhận hóa đơn
  TOTAL: 3, // Bảng kê hóa đơn tổng
  ATTACK_FILE: 30, // Bảng kê tổng hợp PDF/XML
  REPORT_INVOICE_REJECTED_INDAY: "REPORT_INVOICE_REJECTED_INDAY", //"BÁO CÁO HÓA ĐƠN BỊ TỪ CHỐI TRONG NGÀY ",
  INVOICE: "INVOICE",
  INVOICE_POS: "INVOICE_POS",
  INVOICE_WAREHOUSES: "INVOICE_WAREHOUSES",
  INVOICE_WAREHOUSES_AGENCY: "INVOICE_WAREHOUSES_AGENCY",

  TAX_DEDUCT: "TAX_DEDUCT", // Chứng từ khấu trừ
  TAX_DEDUCT_REPORT_TCT: "TAX_DEDUCT_REPORT_TCT", // Report chứng từ khấu trừ cho TCT
  TAX_DEDUCT_USE: "TAX_DEDUCT_USE", // Bảng kê sử dụng chứng từ khấu trừ
  TAX_DEDUCT_TRANSFER: "TAX_DEDUCT_TRANSFER", // Báo cáo đối soát truyền nhận chứng từ khấu trừ (type 5)
  TAX_DEDUCT_EXPORT: "TAX_DEDUCT_EXPORT", // Chứng từ đã xuất theo filter
};

export const TYPE_INVOICE = {
  ADJUST: "ADJUST", // ADJUST
  REPLACE: "REPLACE", // REPLACE
};

export const TYPE_TAX_DEDUCT = {
  ADJUST: "TAX_DEDUCT_ADJUST", // ADJUST
  REPLACE: "TAX_DEDUCT_REPLACE", // REPLACE
};

export const FILE_NAME_REPORT = {
  DATA: "BẢNG KÊ HÓA ĐƠN ", // Bảng kê dữ liệu hóa đơn,
  USE: "BẢNG KÊ TÌNH HÌNH SỬ DỤNG HÓA ĐƠN ", // Bảng kê tình hình sử dụng
  TRANSFER: "BÁO CÁO ĐỐI SOÁT TRUYỀN NHẬN HÓA ĐƠN ", // Báo cáo đối soát truyền nhận hóa đơn
  TOTAL: "BẢNG KÊ HÓA ĐƠN TỔNG ", // Bảng kê hóa đơn tổng,
  ZIP: "BẢNG KÊ TỔNG HỢP PDF/XML ", // BẢNG KÊ TỔNG HỢP PDF/XML
  REPORT_INVOICE_ERROR: "BẢNG TỔNG HỢP THÔNG BÁO GỬI CQT ",
  REPORT_INVOICE_REJECTED_INDAY: "BÁO CÁO HÓA ĐƠN BỊ TỪ CHỐI TRONG NGÀY ", //"BÁO CÁO HÓA ĐƠN BỊ TỪ CHỐI TRONG NGÀY ",
  TAX_DEDUCT_USE: "BẢNG KÊ SỬ DỤNG CHỨNG TỪ KHẤU TRỪ THUẾ THU NHẬP CÁ NHÂN ",
  TAX_DEDUCT_TRANSFER:
    "BÁO CÁO ĐỐI SOÁT TRUYỀN NHẬN CHỨNG TỪ KHẤU TRỪ THUẾ THU NHẬP CÁ NHÂN ",
};

export const PATH_TYPE_REPORT = {
  ZIP: ".zip",
  EXCEL: ".xlsx",
};
